import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum BillColumn {
    DATE = "date",
    STATUS = "status",
    EXTERNAL_STATUS = "externalStatus",
    VENDOR = "vendor",
    ACCOUNT = "account",
    DUE_DATE = "dueDate",
    AMOUNT = "amount",
    OPEN = "open",
    ENTITY = "entity",
    EXTERNAL_LINK = "externalLink",
    INVOICE_NUMBER = "invoiceNumber",
    LOCK = "lock",
    SCHEDULE = "schedule",
    MATCH = "match",
}

export enum BillsByVendorColumn {
    VENDOR = "vendor",
    DUE_1_TO_30 = "due1To30",
    DUE_31_TO_60 = "due31To60",
    DUE_61_PLUS = "due61Plus",
    OVERDUE = "overdue",
    TOTAL_OPEN = "totalOpen",
    TOTAL_PAID = "totalPaid",
    BILLS_COUNT = "billsCount",
    ENTITIES = "entities",
}

export enum BillLineItemColumn {
    DATE = "date",
    STATUS = "status",
    EXTERNAL_STATUS = "externalStatus",
    DESCRIPTION = "description",
    CLASS = "class",
    VENDOR = "vendor",
    ACCOUNT = "account",
    ACCRUAL_ACCOUNT = "accrualAccount",
    ACCOUNTS_PAYABLE = "accountsPayable",
    DUE_DATE = "dueDate",
    AMOUNT = "amount",
    OPEN = "open",
    ENTITY = "entity",
    EXTERNAL_LINK = "externalLink",
    INVOICE_NUMBER = "invoiceNumber",
    LOCK = "lock",
    SCHEDULE = "schedule",
    MATCH = "match",
}

export const BillViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.BILL),
    columns: z.array(
        ColumnSchema.extend({
            id: z.nativeEnum(BillColumn),
        }),
    ),
});

export const BillsByVendorViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.BILLS_BY_VENDOR),
    columns: z.array(
        ColumnSchema.extend({
            id: z.nativeEnum(BillsByVendorColumn),
        }),
    ),
});

export const BillLineItemViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.BILL_LINE_ITEM),
    columns: z.array(
        ColumnSchema.extend({
            id: z.union([
                z.nativeEnum(BillLineItemColumn),
                z.string().startsWith("ledgerAccount:"),
                z.string().startsWith("ledgerPayable:"),
            ]),
        }),
    ),
});

export type BillView = z.infer<typeof BillViewSchema>;
export type BillsByVendorView = z.infer<typeof BillsByVendorViewSchema>;
export type BillLineItemView = z.infer<typeof BillLineItemViewSchema>;
